import { ICommitmentEditorItem } from 'legacy/lut/components/widgets/public/partner360/commitment/models'
import {
  IRequestAcknowledgementParameters,
  requestAcknowledgement,
} from 'legacy/lut/features/partner360/commitment'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'

import { useRefetchPlanningCockpitData } from 'partner360/features/financialCockpit/model/hooks/useRefetchPlanningCockpitData'

import { AcknowledgmentAction } from '../enums/AckonwledgmentAction'

interface IUseCommitmentActions {
  currentItem: ICommitmentEditorItem | undefined
  setIsShowPbmDialog: (value: boolean) => void
  setCurrentItem: (value: ICommitmentEditorItem | undefined) => void
  setIsShowDeleteDialog: (value: boolean) => void
  checkContactIsUnique: (email: string) => boolean
}

export const useCommitmentActions = ({
  currentItem,
  setIsShowPbmDialog,
  setCurrentItem,
  setIsShowDeleteDialog,
  checkContactIsUnique,
}: IUseCommitmentActions) => {
  const dispatch = useAppDispatch()
  const refetchPlanningCockpitData = useRefetchPlanningCockpitData()

  const callAcknowledgmentAction = useCallback(
    async (parameters: IRequestAcknowledgementParameters) => {
      const result = await dispatch(requestAcknowledgement(parameters))
      refetchPlanningCockpitData()
      return result
    },
    [dispatch, refetchPlanningCockpitData]
  )

  const onDeleteApprover = useCallback(
    (item: ICommitmentEditorItem | undefined) => async () => {
      if (currentItem) {
        if (item?.EntryId) {
          await callAcknowledgmentAction({
            partnerId: item.PartnerId,
            fYear: item.FYear,
            programType: item.ProgramType,
            entryId: item.EntryId,
            actionData: {
              Action: AcknowledgmentAction.Remove,
              CommitmentType: currentItem.CommitmentType,
            },
          })
        }
      }
      setIsShowDeleteDialog(false)
    },
    [setIsShowDeleteDialog, currentItem, callAcknowledgmentAction]
  )

  const onChangePbm = useCallback(
    async (item: any) => {
      if (!checkContactIsUnique(item.Email || item.ManagerEmail)) {
        return
      }
      if (currentItem) {
        await callAcknowledgmentAction({
          partnerId: currentItem.PartnerId,
          fYear: currentItem.FYear,
          programType: currentItem.ProgramType,
          entryId: currentItem.EntryId,
          actionData: {
            Action: AcknowledgmentAction.Change,
            Email: item.Email || item.ManagerEmail,
            FirstName: item.FirstName || item.ManagerFirstName,
            LastName: item.LastName || item.ManagerLastName,
            CommitmentType: currentItem.CommitmentType,
          },
        })
      }
      setCurrentItem(undefined)
      setIsShowPbmDialog(false)
    },
    [
      checkContactIsUnique,
      currentItem,
      setCurrentItem,
      setIsShowPbmDialog,
      callAcknowledgmentAction,
    ]
  )
  return { onDeleteApprover, onChangePbm, callAcknowledgmentAction }
}
